import { configDates } from "@/app/infrastructures/misc/common-library/modules/Date";
import { PickupSchedule } from "@/domain/entities/PickupSchedule";

export const formatRepeatDays = (
  obj: PickupSchedule,
  t: (key: string, params?: any) => string,
  isUsingTime = true,
  locale?: string
) => {
  const splitDay = obj.pickupScheduleRepeatDays.split(",");
  const startDay = splitDay.length < 2 ? splitDay : splitDay.slice(0, -1);
  const lastDay = splitDay.slice(-1);

  const convertDay = `${startDay
    .map((key: any) => t(`pickupCorporate.${key}`))
    .join(", ")} ${
    splitDay.length > 1
      ? t("pickupCorporate.andDay", {
          day: t(`pickupCorporate.${lastDay.toString().trim()}`)
        })
      : ""
  }`;

  const tzObj = configDates(obj.pickupScheduleCityTimezone);
  const tzLabel =
    locale?.toLowerCase() === "my" && tzObj.my ? tzObj.my : tzObj.id;

  if (
    obj.pickupScheduleIntervalWeek === 0 ||
    !obj.pickupScheduleRepeatDays.length
  ) {
    return "-";
  }

  return t("pickupCorporate.repeatScheduleLabel", {
    days: convertDay,
    time: isUsingTime && tzLabel ? `${obj.pickupScheduleTime} ${tzLabel}` : "",
    interval: obj.pickupScheduleIntervalWeek
  });
};

export default formatRepeatDays;
